module.exports = __webpack_public_path__ + "assets/img/travel-day31.9f8d02a1.png";